/* cspell:disable */
import posthog from 'posthog-js'

import { ANALYTICS_READY_EVENT } from './src/utils/analytics-service'

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: '/ingest',
    ui_host: 'https://us.posthog.com',
    defaults: '2026-01-30',
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_performance: false,
    disable_session_recording: true,
    disable_compression: true,
    loaded: () => {
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event(ANALYTICS_READY_EVENT))
      }
    }
  })
}
